export const FILETYPES = [
  { type: 'application/pdf', label: '.pdf' },
  // { type: 'application/msword', label: '.doc' },
  // { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', label: '.docx' },
];
